"use client";

import { useSession } from "next-auth/react";
import { useRouter } from "next/navigation";
import { InfoIcon } from "~/components/icons";
import { api } from "~/trpc/react";

export function EmailBanner() {
  const { data: session } = useSession();
  const router = useRouter();
  
  const userId = session?.user?.id ? parseInt(session.user.id) : null;
  
  const { data: account } = api.accounts.getById.useQuery(
    { id: userId ?? 0 },
    { enabled: !!userId }
  );

  if (!account || account.email) {
    return null;
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8 pt-4 sm:pt-6 lg:pt-8">
      <div className="flex w-full items-center gap-3 rounded-lg border border-[rgba(0,100,193,0.27)] bg-[rgba(0,85,199,0.04)] p-4 overflow-hidden">
        <div className="flex h-5 items-center shrink-0">
          <InfoIcon className="h-4 w-4 text-[#4c6f90]" />
        </div>
        <p className="flex-1 text-sm leading-5 text-[#1c2024] min-w-0">
          Your account is missing an email address. Please add one to continue.
        </p>
        <button
          onClick={() => router.push('/settings')}
          className="shrink-0 h-6 px-2 text-xs font-medium leading-4 text-[#f6f9fd] bg-[#1c3144] rounded hover:bg-[#2a4558] transition-colors whitespace-nowrap"
        >
          Update Account
        </button>
      </div>
    </div>
  );
}

